import React, { Component } from "react";

export interface InputProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
    disabled?: boolean;
    isConfig?: boolean;
}

export default class BaseInput extends Component<InputProps, {}> {
    render() {
        const {isConfig, ...restProps} = this.props
        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."
            || (isConfig && !this.props.disabled)
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                  this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "input-group " + (errors ? "input-group-error" : "")
                    }
                >
                    <input
                        type={this.props.inputtype}
                        className="input"
                        placeholder={this.props.placeholder}
                        spellCheck={false}
                        {...this.props.field}
                        {...restProps}
                        value={this.props.field.value || ""}
                        onChange={(...args) => {
                            const { field } = this.props;
                            let { touched } = this.props.form;
                            touched[field.name] = true;
                            this.props.form.setTouched(touched);
                            field.onChange(...args);
                        }}
                    />
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
